// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  availableEvents: {
    name: 'availableEvents',
    componentName: 'AvailableEventsContainer',
    chunk: () => import(
      /* webpackChunkName: "availableEvents" */
      './pages/available-events/AvailableEventsContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/available-events/AvailableEventsContainer.js')).AvailableEventsContainer
        : currentRouteName === 'availableEvents'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.AvailableEventsContainer })));
    },
    path: '/:context?/workshops/',
    channel: null
  }
});
